import {
    GET_ASSET_ITEM_STATUS_TASK_DETAIL,
    SET_ASSET_ITEM_STATUS_TASK_DETAIL,
    SET_IS_ASSET_ITEM_STATUS_TASK_DETAIL_CALLED
} from "./AssetItemStatusTaskDetailsType"

const getAssetItemStatusTaskDetail = (fleetDetails: any) => ({
    type: GET_ASSET_ITEM_STATUS_TASK_DETAIL,
    fleetDetails
})

const setAssetItemStatusTaskDetail = (assetItemStatusTaskDetail: any) => ({
    type: SET_ASSET_ITEM_STATUS_TASK_DETAIL,
    assetItemStatusTaskDetail: assetItemStatusTaskDetail
})

const SetIsAssetItemStatusTaskDetailCalled = (fleetDetailId : any , isLoading : any) => {
    return {
      type: SET_IS_ASSET_ITEM_STATUS_TASK_DETAIL_CALLED,
      fleetDetailId,
      isLoading: isLoading
    };
  }


export {
    getAssetItemStatusTaskDetail,
    setAssetItemStatusTaskDetail,
    SetIsAssetItemStatusTaskDetailCalled
}